import type { AmbassadorCard as IAmbassadorCard } from '@bulknutrients/bulk-shared-lib/interfaces/Ambassador';
import { CustomImage } from '@components/Media/Image';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { Tag } from '@components/Typography/Tag/Tag';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import Link from 'next/link';
import type { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

export function AmbassadorCard({
  ambassador,
}: {
  ambassador: IAmbassadorCard;
}): ReactElement {
  const { setValue } = useFormContext();
  return (
    <div className="card flex h-full flex-col justify-between p-2.5 rounded-2xl  transition-all duration-300 hover:scale-103">
      <div>
        <div id="thumb" className="xl:float-right">
          <CustomImage image={ambassador.thumbnail} width={150} height={150} />
        </div>
        <h3 className="pb-2">
          <TextLink href={ambassador.slug}>{ambassador.name}</TextLink>
        </h3>
        <div className="flex flex-wrap gap-2">
          {ambassador?.tags.map((tag, i) => (
            <Tag
              onClick={() => setValue(tag.parent, tag.title)}
              key={`tag-${i}`}
            >
              {tag.title}
            </Tag>
          ))}
        </div>
        <Paragraph>{ambassador.shortDescription}</Paragraph>
      </div>
      <Link
        prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
        href={ambassador.slug}
        className="clear-both -m-2.5 mt-0 block w-[calc(100%+20px)] bg-grey-dark px-0 py-2.5 text-center text-sm uppercase text-white no-underline hover:bg-orange rounded-b-2xl"
      >
        View profile and recommendations
      </Link>
    </div>
  );
}
